import { render, staticRenderFns } from "./FullPageChart.vue?vue&type=template&id=0f81d210"
import script from "./FullPageChart.vue?vue&type=script&lang=js"
export * from "./FullPageChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports